module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_eyess.37165de4.png";